import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import TabsConversion from '@/components/TabsConversion'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/overseasSales/customerCenter/components/baseMessage.vue'
import tabsContract from '@/views/overseasSales/customerCenter/components/tabsContract.vue'
import ViewFooterBtn from '@/views/overseasSales/customerCenter/components/viewFooterBtn.vue'
import tabsCode from '@/views/overseasSales/customerCenter/components/tabsCode.vue'
import tabsBusiness from '@/views/overseasSales/customerCenter/components/tabsBusiness.vue'
import tabsMainBody from '@/views/overseasSales/customerCenter/components/tabsMainBody.vue'
import tabsAlarmList from '@/views/overseasSales/customerCenter/components/tabsAlarmList.vue'
import { potentialDetail } from '@/api/overseasSales/customerCenter'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const __default__ = {
  name: 'FbuClientsView'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const route = useRoute()
const data = ref({})
const operationLogRef = ref()
const contactsRef = ref()
const activeKey = ref('base')
const loading = ref(false)
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
          res.data.business.businessTypeSelect = res.data.business.businessType[0]
        }
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 标签页切换
const changeTabs = (v: string) => {
  if (v === 'base') {
    fetch()
  } else if (v === 'operationLog') {
    // 更新联系人或者操作日志
    if (activeKey.value === 'contact') {
      contactsRef.value?.refresh()
    } else if (activeKey.value === 'operationLog') {
      operationLogRef.value?.fetch()
    }
  }
}
onMounted(() => {
  fetch()
})
const permissionBasic = {
  transfer: 'ofbu_clients_transfer_btn',
  follow_add: 'ofbu_clients_follow_add_btn',
  visitor_add: 'ofbu_clients_visitor_add_btn',
  edit: 'ofbu_clients_edit_btn',
  buss_add: 'ofbu_clients_buss_add_btn',
  concat_add: 'ofbu_clients_concat_add_btn'
}
const permissionFollow = {
  edit: 'ofbu_clients_follow_edit_btn',
  del: 'ofbu_clients_follow_del_btn',
  comment: 'ofbu_clients_follow_comment_btn'
}
const permissionBuss = {
  edit: 'ofbu_clients_buss_edit_btn',
  del: 'ofbu_clients_buss_del_btn'
}
const permissionConcat = {
  edit: 'ofbu_clients_concat_edit_btn',
  del: 'ofbu_clients_concat_del_btn'
}
const footerSuccess = (tag: 'base' | 'contact') => {
  if (tag === 'base') {
    fetch()
  } else if (tag === 'contact') {
    contactsRef.value?.refresh()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, {
            header: "",
            title: data.value?.customerInfo?.customerName || '--',
            sellerName: data.value?.customerInfo?.sellerName,
            customLabel: _unref(t)('custom.customerNumber'),
            customValue: data.value?.customerInfo?.customerNumber
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                onChange: changeTabs,
                activeKey: activeKey.value,
                "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "base",
                    tab: _unref(t)('common.baseTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(baseMessage, {
                        disabled: true,
                        formItemView: "",
                        data: data.value,
                        type: "clients",
                        permissionPage: permissionBasic
                      }, null, 8, ["data"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "contact",
                    tab: _unref(t)('common.concatTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsContacts, {
                        ref_key: "contactsRef",
                        ref: contactsRef,
                        appId: "cos_ofbu",
                        contactRefId: _unref(route).query.cosId,
                        permissionPage: permissionConcat
                      }, null, 8, ["contactRefId"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "3",
                    tab: _unref(t)('common.followTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsClueCosFollowUp), {
                        appId: "cos_ofbu",
                        workCode: data.value.customerInfo.seller,
                        showFooter: true,
                        followRefId: _unref(route).query.cosId,
                        permissionPage: permissionFollow
                      }, null, 8, ["workCode", "followRefId"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "4",
                    tab: _unref(t)('common.bussiessTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsBusiness, {
                        workCode: data.value.customerInfo.seller,
                        permissionPage: permissionBuss
                      }, null, 8, ["workCode"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "5",
                    tab: _unref(t)('common.contractTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsContract)
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "6",
                    tab: _unref(t)('common.conversionTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsConversion), {
                        resourceId: _unref(route).query.cosId,
                        appId: "cos_ofbu"
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "operationLog",
                    tab: _unref(t)('common.operationLogTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsOperationLog, {
                        ref_key: "operationLogRef",
                        ref: operationLogRef,
                        tableId: "DcCosOFbuClientsOperationLog",
                        appId: "cos_ofbu",
                        resourceId: _unref(route).query.cosId
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "8",
                    tab: _unref(t)('common.arkCodeTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsCode)
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "9",
                    tab: _unref(t)('common.subjectTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsMainBody)
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "10",
                    tab: _unref(t)('exception.exceptionSituation')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsAlarmList, {
                        cosId: _unref(route).query.cosId
                      }, null, 8, ["cosId"])
                    ]),
                    _: 1
                  }, 8, ["tab"])
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          }, 8, ["title", "sellerName", "customLabel", "customValue"]),
          _createVNode(ViewFooterBtn, {
            permissionPage: permissionBasic,
            onSuccess: footerSuccess,
            loading: loading.value,
            type: "clients",
            workCode: data.value?.customerInfo?.seller
          }, null, 8, ["loading", "workCode"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})